class WhatsInTheBoxCarousel extends HTMLElement {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.onDotClick = this.onDotClick.bind(this);
    this.onBlockSelect = this.onBlockSelect.bind(this);
    this.frame = null;
  }

  connectedCallback() {
    this.track = this.querySelector('.whats-in-the-box__track');
    this.cards = Array.from(this.querySelectorAll('.whats-in-the-box__card'));
    this.dots = Array.from(this.querySelectorAll('.whats-in-the-box__dot'));

    if (!this.track || this.cards.length === 0) return;

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  onScroll() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.setActiveDot(this.getCurrentIndex());
    });
  }

  onDotClick(event) {
    const index = this.dots.indexOf(event.currentTarget);
    if (index === -1) return;
    this.goToCard(index);
    this.setActiveDot(index);
  }

  onBlockSelect(event) {
    const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail?.blockId);
    if (index === -1) return;
    this.goToCard(index);
    this.setActiveDot(index);
  }

  getCurrentIndex() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    if (maxScroll > 0 && this.track.scrollLeft >= maxScroll - 1) return this.cards.length - 1;

    const origin = this.cards[0].offsetLeft;
    const scrollLeft = this.track.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Infinity;

    this.cards.forEach((card, index) => {
      const distance = Math.abs(card.offsetLeft - origin - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  goToCard(index) {
    const card = this.cards[index];
    if (!card) return;
    this.track.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'instant' });
  }

  setActiveDot(activeIndex) {
    this.dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('whats-in-the-box__dot--active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('whats-in-the-box-carousel')) {
  customElements.define('whats-in-the-box-carousel', WhatsInTheBoxCarousel);
}
